import { Pipe, PipeTransform } from '@angular/core';

import { QUOTE_STATUSES, QuoteStatus } from '@lockton-apps/shared/interfaces';

import { QuoteStatusMetaPipe } from './quote-status.pipe';

@Pipe({
  name: 'paymentStatus',
  standalone: true,
})
export class PaymentStatusPipe
  extends QuoteStatusMetaPipe<{ label: string; icon: string }>
  implements PipeTransform
{
  map = new Map<QuoteStatus, { label: string; icon: string }>([
    [
      QUOTE_STATUSES.FormInitialized,
      { label: $localize`Pending`, icon: 'more' },
    ],
    [QUOTE_STATUSES.FormSent, { label: $localize`Pending`, icon: 'more' }],
    [
      QUOTE_STATUSES.FormIncomplete,
      { label: $localize`Pending`, icon: 'more' },
    ],
    [QUOTE_STATUSES.FormComplete, { label: $localize`Pending`, icon: 'more' }],
    [QUOTE_STATUSES.OnHold, { label: $localize`Pending`, icon: 'more' }],
    [
      QUOTE_STATUSES.HealthEvaluationRequired,
      { label: $localize`Pending`, icon: 'more' },
    ],
    [QUOTE_STATUSES.Quoted, { label: $localize`Pending`, icon: 'more' }],
    [
      QUOTE_STATUSES.BrokerApproved,
      { label: $localize`Pending`, icon: 'more' },
    ],
    [QUOTE_STATUSES.QuoteAccepted, { label: $localize`Pending`, icon: 'more' }],
    [
      QUOTE_STATUSES.AwaitingPayment,
      {
        label: $localize`Awaiting payment`,
        icon: 'invoice_sent_universal_thin',
      },
    ],
    [
      QUOTE_STATUSES.Complete,
      {
        label: $localize`Payment received`,
        icon: 'invoice_paid_universal_thin',
      },
    ],
    [QUOTE_STATUSES.QuoteError, { label: 'Error', icon: '' }],
  ]);

  defaultValue = { label: 'Unknown', icon: 'help' };
}
